import React from 'react'

import { useNumericParams } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

import defaultRequestOptions from '@sections/Admin/packs/SystemManager/defaultRequestOptions'

import UserEditRoutes from './routes'

const Edit = () => {
  const { userId } = useNumericParams()

  useReduxAction(
    'users',
    'loadUser',
    {
      entityId: userId,
      ...defaultRequestOptions.user,
    },
    [userId],
    {
      dispatchAction: (action, requestOptions) => action(userId, requestOptions),
      shouldPerformFn: ({ loading }) => userId && !loading,
    },
  )

  return (
    <UserEditRoutes />
  )
}

export default Edit
